// apiServiceDashboard.js
import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const apiServiceDashboard = {
  getDeletedCustomDashboards: async (companyid) => {
    try {
      const apiUrl = `${BASE_URL}/dashboards/list/${companyid}/custom/deleted`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.log("apiServiceDashboard (ERROR): getDeletedCustomDashboards ", error.message);
      throw error;
    }
  },

  restorecustombyid: async (dashboardid) => {
    console.log("Dash ", dashboardid)
    try {
      const apiUrl = `${BASE_URL}/dashboards/${dashboardid}/custom/restore`;
      const headers = createHeaders();
      const reqbody = { restore: dashboardid };
      const response = await axios.post(apiUrl, reqbody, { headers });
      return response.data;
    } catch (error) {
      console.log("apiServiceDashboard (ERROR): restorecustombyid ", error.message);
      throw error;
    }
  },

  getDeletedClassicDashboards: async (companyid) => {
    try {
      const apiUrl = `${BASE_URL}/dashboards/list/${companyid}/classic/deleted`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.log("apiServiceDashboard (ERROR): getDeletedClassicDashboards ", error.message);
      throw error;
    }
  },

  restoreClassicbyid: async (dashboardid) => {
    try {
      const apiUrl = `${BASE_URL}/dashboards/${dashboardid}/classic/restore`;
      const headers = createHeaders();
      const reqbody = { restore: dashboardid };
      const response = await axios.post(apiUrl, reqbody, { headers });
      return response.data;
    } catch (error) {
      console.log("apiServiceDashboard (ERROR): restoreClassicbyid ", error.message);
      throw error;
    }
  }
  // Define more functions as needed
};

export default apiServiceDashboard;
